import { render, staticRenderFns } from "./ListCustomerCare.vue?vue&type=template&id=6e4e7e03&"
import script from "./ListCustomerCare.vue?vue&type=script&lang=js&"
export * from "./ListCustomerCare.vue?vue&type=script&lang=js&"
import style0 from "./ListCustomerCare.vue?vue&type=style&index=0&id=6e4e7e03&prod&lang=css&"
import style1 from "./ListCustomerCare.vue?vue&type=style&index=1&id=6e4e7e03&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports